import { ROUTE_IDS } from '../../experience/routes/ids.js';
import { PLATFORM_ROOT_ACCESS_PROFILE } from './platform-root.access-profile.js';
import { COMMON_AVATAR_ROUTE_IDS, PLATFORM_ROOT_ADMIN_BASELINE_MODULES, PLATFORM_ROOT_ADMIN_DENIED_ROUTE_IDS, PLATFORM_ROOT_ADMIN_FORBIDDEN_MODULES, } from './presets.js';
export const PLATFORM_ADMIN_ACCESS_PROFILE = {
    persona: 'PLATFORM_ADMIN',
    actorTypes: ['USER', 'SERVICE_ACCOUNT'],
    scope: {
        allowedKinds: ['SYSTEM', 'PLATFORM'],
        defaultKind: 'PLATFORM',
        organizationRequired: false,
        branchRequired: false,
        clientRequired: false,
        ownershipPolicy: 'PLATFORM',
    },
    authentication: {
        defaultAal: 'AAL2',
        administrationAal: 'AAL2',
    },
    navigation: {
        landingRouteId: ROUTE_IDS.DASHBOARD,
        primaryRouteIds: [
            ROUTE_IDS.DASHBOARD,
            ROUTE_IDS.DATA_HUB,
            ROUTE_IDS.REPORTS,
            ROUTE_IDS.ADMIN_HUB,
        ],
        avatarRouteIds: COMMON_AVATAR_ROUTE_IDS,
        structurallyDeniedRouteIds: PLATFORM_ROOT_ADMIN_DENIED_ROUTE_IDS,
    },
    access: {
        defaultOperationBundleIds: ['platform-admin'],
        allowedOperationBundleIds: ['platform-admin'],
    },
    modules: {
        baseline: PLATFORM_ROOT_ADMIN_BASELINE_MODULES,
        optional: [],
        forbidden: PLATFORM_ROOT_ADMIN_FORBIDDEN_MODULES,
    },
    administration: {
        // Platform Admin manages the same platform-owned resources as Platform Root.
        // SYSTEM versus PLATFORM scope remains the authority boundary; neither
        // persona receives organization business data without delegation.
        resourceIds: PLATFORM_ROOT_ACCESS_PROFILE.administration.resourceIds,
    },
    context: {
        maySwitchOrganization: false,
        maySwitchBranch: false,
        maySelectClient: false,
        maySelectPortfolio: false,
    },
    delegation: {
        mayInitiate: true,
        mayReceive: false,
        organizationDataRequiresDelegation: true,
    },
    mutationPolicy: 'FULL_WITHIN_SCOPE',
};
